const mediaItems = [
  {
    title: '《奔跑吧》名场面合集',
    desc: '本季最搞笑、最感人的高光时刻全收录',
    duration: '15:28',
    views: '128.5万',
    img: 'https://readdy.ai/api/search-image?query=A%20dynamic%20outdoor%20game%20show%20highlight%20moment%20with%20colorful%20props%20and%20energetic%20atmosphere%2C%20bright%20sunlight%2C%20action%20scene%20with%20motion%20blur%2C%20warm%20vibrant%20colors%2C%20cinematic%20video%20thumbnail%20style%2C%20entertainment%20production%20quality&width=600&height=400&seq=media-01-51movies&orientation=landscape',
  },
  {
    title: '《乘风2024》姐姐舞台纯享',
    desc: '精选最惊艳的公演舞台表演完整回顾',
    duration: '22:15',
    views: '96.3万',
    img: 'https://readdy.ai/api/search-image?query=A%20spectacular%20music%20stage%20performance%20with%20golden%20spotlights%20and%20dramatic%20lighting%2C%20elegant%20stage%20design%2C%20theatrical%20fog%20effects%2C%20warm%20amber%20and%20coral%20tones%2C%20cinematic%20video%20thumbnail%20style%2C%20concert%20atmosphere&width=600&height=400&seq=media-02-51movies&orientation=landscape',
  },
  {
    title: '《王牌对王牌》笑点密集集锦',
    desc: '沈腾贾玲搞笑名场面全程高能不断',
    duration: '18:42',
    views: '156.8万',
    img: 'https://readdy.ai/api/search-image?query=A%20colorful%20comedy%20show%20studio%20scene%20with%20bright%20warm%20lighting%2C%20playful%20game%20props%2C%20festive%20atmosphere%2C%20entertainment%20variety%20show%20setting%2C%20vibrant%20orange%20and%20yellow%20tones%2C%20cinematic%20video%20thumbnail%20style&width=600&height=400&seq=media-03-51movies&orientation=landscape',
  },
  {
    title: '《这就是街舞》炸裂Battle',
    desc: '全球顶尖舞者巅峰对决神仙打架现场',
    duration: '12:56',
    views: '89.7万',
    img: 'https://readdy.ai/api/search-image?query=An%20intense%20street%20dance%20battle%20stage%20with%20dynamic%20warm%20lighting%2C%20urban%20industrial%20venue%2C%20dramatic%20spotlights%2C%20motion%20energy%2C%20vibrant%20orange%20and%20amber%20neon%20accents%2C%20cinematic%20video%20thumbnail%20style&width=600&height=400&seq=media-04-51movies&orientation=landscape',
  },
];

export default function MediaSection() {
  return (
    <section id="media" className="py-14 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6 lg:px-8">
        <div className="max-w-7xl mx-auto">
          <div className="text-center mb-10 md:mb-14">
            <span className="inline-block px-4 py-1.5 rounded-full bg-primary-100 text-primary-700 text-xs font-semibold mb-4 whitespace-nowrap">
              精彩片段
            </span>
            <h2 className="text-2xl md:text-3xl lg:text-4xl font-black text-foreground-950" style={{ fontFamily: 'var(--font-heading)' }}>
              不容错过的综艺高光时刻
            </h2>
            <p className="text-foreground-500 text-sm md:text-base mt-3 max-w-2xl mx-auto">
              精选最精彩的综艺片段，名场面一次看过瘾
            </p>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5 md:gap-6">
            {mediaItems.map((item) => (
              <div
                key={item.title}
                className="bg-background-50 rounded-2xl overflow-hidden border border-background-200 hover:border-primary-200 transition-all group cursor-pointer"
              >
                <div className="relative overflow-hidden">
                  <img
                    src={item.img}
                    alt={item.title}
                    className="w-full h-44 md:h-48 object-cover group-hover:scale-105 transition-transform duration-500"
                    loading="lazy"
                  />
                  <div className="absolute inset-0 bg-black/20 group-hover:bg-black/30 transition-all flex items-center justify-center">
                    <div className="w-14 h-14 flex items-center justify-center rounded-full bg-white/90 text-primary-500 group-hover:bg-primary-500 group-hover:text-white group-hover:scale-110 transition-all shadow-lg">
                      <i className="ri-play-fill text-2xl ml-0.5"></i>
                    </div>
                  </div>
                  <div className="absolute bottom-2 right-2 bg-black/70 text-white text-xs px-2 py-0.5 rounded-md whitespace-nowrap">
                    {item.duration}
                  </div>
                </div>
                <div className="p-4 md:p-5">
                  <h3 className="text-sm md:text-base font-bold text-foreground-900 mb-1 group-hover:text-primary-600 transition-colors line-clamp-2">
                    {item.title}
                  </h3>
                  <p className="text-foreground-500 text-xs mb-3 line-clamp-2">
                    {item.desc}
                  </p>
                  <div className="flex items-center gap-3 text-xs text-foreground-500">
                    <span className="flex items-center gap-1">
                      <i className="ri-eye-line"></i> {item.views}
                    </span>
                    <span className="flex items-center gap-1">
                      <i className="ri-heart-line"></i> 收藏
                    </span>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}